import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReceiptCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V21.9732L8.5 19.4018L12 21.4018L15.5 19.4018L20 21.9732V2H4ZM9 13H15V15H9V13ZM15.1642 7.55L13.75 6.13579L11.3 8.58579L10.25 7.53579L8.83579 8.95L11.3 11.4142L15.1642 7.55Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptCheck;
